export const PERSIST_ENTERED_INFO = 'PERSIST_ENTERED_INFO'
export const GET_COMPARABLE_FULL_LIST = 'GET_COMPARABLE_FULL_LIST'
export const SET_COMPARABLE_FULL_LIST = 'SET_COMPARABLE_FULL_LIST'
